import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import ButtonIconGhostMedium from '../ButtonIconGhost/ButtonIconGhostMedium';
import { Icon } from '../../icon/icon';
import { cn } from '../../../utils/string/cn.utils';

const RenderModal = ({ onClose, ...config }) => {
  const { classNames = {}, title, closable, content } = config;
  const [_open, _setOpen] = useState(false);

  useEffect(() => {
    _setOpen(true);
  }, []);

  return (
    <Modal
      {...config}
      open={_open}
      classNames={{
        content: cn(
          '!p-0 !m-[0px] !rounded-[24px] overflow-hidden',
          classNames?.content
        ),
        header: cn(
          // 'm-[0px] flex items-start justify-start self-stretch px-[24px] pt-[32px] pb-[16px]',
          '[&_.ant-modal-title]:relative',
          classNames?.header
        ),
        body: cn(
          // 'py-[16px] px-[24px] gap-[24px] flex items-center justify-center flex-col m-[0px]',
          classNames?.body
        ),
        footer: cn('m-[0px]', classNames?.footer),
      }}
      closable={false}
      title={
        <>
          {title}
          {closable !== false && (
            <ButtonIconGhostMedium
              icon={<Icon.ICClose />}
              onClick={() => {
                _setOpen(false);
                setTimeout(() => {
                  onClose?.();
                }, 300);
              }}
              className={cn(
                'absolute top-[50%] right-0 transform -translate-y-[50%]',
                classNames.iconClose
              )}
            />
          )}
        </>
      }
    >
      {content}
    </Modal>
  );
};

export default RenderModal;
